module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }